import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import "rc-slider/assets/index.css";
import "./styles/index.scss";
import "./index.css";
import "./fonts/line-awesome-1.3.0/css/line-awesome.css";
import App from './App';
import reportWebVitals from './reportWebVitals';

const Root = () => {
  const monitoredPaths = [ '/guest-form', '/checkout', '/mercadopago-form', '/payment', '/pay-done']; 
  const [showModal, setShowModal] = useState(false);
  const [ignoreNextPopState, setIgnoreNextPopState] = useState(false);

  useEffect(() => {
    const handlePopState = () => {
      // Solo mostrar el modal si no estamos ignorando el próximo popstate
      if (monitoredPaths.includes(window.location.pathname) && !ignoreNextPopState) {
        setShowModal(true);
      } else {
        // Si ignoramos el popstate, lo reseteamos después de que pase
        setIgnoreNextPopState(false);
      }
    };

    // Listener para interceptar el evento 'popstate'
    window.addEventListener('popstate', handlePopState);

    return () => {
      // Limpiar el listener cuando el componente se desmonte
      window.removeEventListener('popstate', handlePopState);
    };
  }, [monitoredPaths, ignoreNextPopState]);

  // Función para confirmar la navegación hacia atrás
  const confirmNavigation = () => {
    setShowModal(false);
    window.location.href = '/listing-stay-detail';
  };

  // Función para cancelar la navegación hacia atrás
  const cancelNavigation = () => {
    setShowModal(false);
    // Establecemos que se ignore el siguiente evento de popstate
    setIgnoreNextPopState(true);
    // Avanzamos en el historial
    window.history.forward();
  };

  return (
    <>
      {/* Modal de confirmación */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-96">
            <h2 className="text-xl font-semibold mb-4">Confirmar Navegación</h2>
            <p className="mb-4">Si retrocedes, se perderá la información de la reserva. ¿Deseas continuar?</p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={cancelNavigation}
                className="bg-gray-500 text-white px-4 py-2 rounded-full hover:bg-gray-600"
              >
                Cancelar
              </button>
              <button
                onClick={confirmNavigation}
                className="bg-blue-600 rounded-full text-white px-4 py-2 hover:bg-red-700"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

     { !showModal && <App /> }
    </>
  );
};

// Renderizar la aplicación
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Root />
);

reportWebVitals();